import React from "react";
// import { useState } from "react";
import { useTranslation } from "react-i18next";


function Accessibility() {
    const { t } = useTranslation();

    return (
        <div className='InternalPage'>
            <section className='InternalHead'>
                <div className='internal-text'>
                    <h1 className='center'>{t("yslearn.in and Accessibility")}</h1>
                </div>
            </section>

            <section className='InternalBody'>
                <div className='accessibility-wrapper'>
                    <div className='section-title'>{t("Accessibility Statement")}</div>
                    <p>yslearn.in provides access to education beyond boundaries and without barriers. Our tools for both learners and instructors are ADA (Americans with Disabilities Act) and AODA (Accessibility for Ontarians with Disabilities Act) compliant.</p>
                    <p>Access to education should reduce all barriers to full participation in our society, whether those barriers are social, physical or psychological. This philosophy is yslearn.in’s core reason for being.</p>
                    <p>In accordance with AODA, our tools have been designed to the support the four columns of accessibility for people with disabilities (PWD):</p>
                    
                    <p>Should you encounter any barriers to using our tools as a PWD, please contact us at <a href="mailto:support@yslearn.in">support@yslearn.in</a> to share your experiences and give us an opportunity to address those barriers in our next update. While we have tried to anticipate every user outcome, we recognize that your circumstances may require accommodations we must design and implement.</p>
                    <p>yslearn.in staff in Ontario have undertaken training in Accessibility for Ontarians with Disabilities Act (AODA) in compliance with the <a target="_blank" rel="noopener noreferrer" href="http://www.ohrc.on.ca/en/ontario-human-rights-code">Ontario Human Rights Code</a>.</p>
                </div>
            </section>
        </div>
    );
}

export default Accessibility;
